import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, TextInput } from "flowbite-react"
import { HiOutlineBookOpen } from "react-icons/hi";
import { FiFolderPlus } from "react-icons/fi";
import { FaRegTimesCircle } from 'react-icons/fa';
import { openSnackBar } from '../../redux/snackBarReducer';
import swal from 'sweetalert2';
import { useTranslation } from "react-i18next";

function CreateGroupModal(props) {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        // dispatch(getMenuTotalCount(id, company))
    }, [])


    const [modalShow, setModalShow] = useState(false);    //modal modalShow hide
    const [search, setSearch] = useState("");   //search bar text 

    const changeSearch = (e) => {
        setSearch(e.target.value);
    }

    const createNewGroup = () => {
        if (search) {
            props.addGroup(search);
            close();
        } else {
            dispatch(openSnackBar({ message: t("msg_fill_group_name"), status: 'error' }));
        }
    }

    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });

    }

    function close() {
        setModalShow(false);
        setSearch("");
    }

    return (
        <>
            <div>
                <Button onClick={() => setModalShow(true)} color="red" outline={true} className=" border-2 border-gray-200 bg-white hover:!bg-white text-indigo-400" >
                    {/* <FiFolderPlus className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5  w-5 text-indigo-500 " stroke-width="1.5">
                        <path d="M8.25 18.75L2.447 18.75" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20.25,8.25v-3a1.5,1.5,0,0,0-1.5-1.5H8.25V2.25A1.5,1.5,0,0,0,6.75.75H2.25a1.5,1.5,0,0,0-1.5,1.5v14.8a1.7,1.7,0,0,0,3.336.438L6.437,9.334A1.5,1.5,0,0,1,7.879,8.25H21.75A1.5,1.5,0,0,1,23.2,10.136" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.25 14.25L17.25 20.25" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.25 17.25L20.25 17.25" fill="none" stroke="blue" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <div className="text-indigo-600">
                            {t("create_new_group")}
                        </div>
                </Button>
            </div>
            <Modal
                show={modalShow}
                size="md"
                popup={true}
                onClose={() => closeModal()}
            >
                <Modal.Header className="px-6 py-5">
                    {t("create_new_group")}
                </Modal.Header>
                <hr />
                <Modal.Body>
                    <div className="py-6">
                        <div className="m-2 ml-2 text-sm block">
                            {t("group_name")}<span className='text-red-700'>*</span>
                        </div>
                        <TextInput
                            id="searchmenu"
                            type="search"
                            sizing="lg"
                            // placeholder="Wine Menu Name"
                            required={true}
                            // icon={HiOutlineSearch}
                            value={search}
                            onChange={(e) => changeSearch(e)}
                        />
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap items-center gap-4 m-auto">
                        <div>
                            <Button onClick={() => closeModal()} color="red" outline={true} className="bg-white border-2 border-gray-300 bg-opacity-0 ">
                                {/* <FaRegTimesCircle className="mr-2 h-5 w-5" /> */}
                                <svg viewBox="0 0 24 24" className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M15.182 8.818L8.818 15.181" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.818 8.818L15.182 15.181" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                {t("dismiss")}
                            </Button>
                        </div>
                        <div>
                            <Button onClick={() => createNewGroup()} outline={false} color="red" className="bg-indigo-500 hover:!bg-indigo-400" >
                                {/* <HiOutlineBookOpen className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                                <svg className="mr-2 h-5 w-5 text-sitebg-50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5">
                                <path d="M8.25 18.75L2.447 18.75" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.25,8.25v-3a1.5,1.5,0,0,0-1.5-1.5H8.25V2.25A1.5,1.5,0,0,0,6.75.75H2.25a1.5,1.5,0,0,0-1.5,1.5v14.8a1.7,1.7,0,0,0,3.336.438L6.437,9.334A1.5,1.5,0,0,1,7.879,8.25H21.75A1.5,1.5,0,0,1,23.2,10.136" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.25 14.25L17.25 20.25" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.25 17.25L20.25 17.25" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                <div className="text-white">
                                    {t("create_new_group")}
                                </div>
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CreateGroupModal;
